<template>
  <div class="row">
    <div class="col-lg-12">
      <loader v-if="!isLoaded"></loader>

      <div class="row">
        <div class="col-12">
          <table-view
              :options="options"
              :isLoaded=isLoaded
              :isChange=isChange>


            <div slot="action" slot-scope="props">

              <client-btn :item="props.row"
                          :showEdit="true"
                          :showDelete="true"
                          v-on:editItem="onModalBtnClick(props.row)"
                          v-on:deleteItem="onDeleteBtnClick(props.row.id)">
              </client-btn>

            </div>
          </table-view>

          <div class="row pager-btn-row">
            <div class="col-md-12 text-right">
              <mdc-button class="button-primary" raised @click="onAddModalBtnClick">
                {{ 'report.add_skill' | trans }}
              </mdc-button>
            </div>
          </div>
        </div>
      </div>

    </div>

    <skill-modal v-if="isModalVisible"
                    :visible="isModalVisible"
                   :data="modal.data"
                   v-on:close="onModalClose">
    </skill-modal>


  </div>
</template>

<script>

    import TableView from '../../../common/table/components/TableView';
    import lang from '../../../lang/translator';
    import {mapGetters} from 'vuex';
    import axios from 'axios';
    import Manager from '../api/Manager';
    import Loader from '../../loader/components/Loader';
    import skillModal from './SkillModal';
    import {Validator} from 'vee-validate';
    import clientBtn from '../../user/client/components/ClientBtn'

    export default {
    name: 'ClinicalCenter',
    data() {
      return {
        apiUrl: '/users/centers',
        isModalVisible: false,
        client: {},
        isChange: false,
        disabled: false,
        isLoaded: true,
        loading: false,
        lastId: null,
        isLastPage: false,
        baseUrl: process.env.APP_URL,
        modal: {
          data: {},
        },
        options: {
          pageHeader: 'skillDomain',
          filterable: false,
          initialPage: null,
          debounce: 1000,
          sortable: [],
          skin: 'table table-sm',
          columns: [
            {
              key: 'name',
              changed: false,
              headings: lang.get('profile.name'),
            },
            {
              key: 'action',
              changed: true,
              headings: '',
            },
          ],

          requestFunction: this.requestFunction,
          responseAdapter: function(resp) {
            return {
              data: resp.data.data.items,
              count: resp.data.data.total,
            };
          },
          texts: {
            filter: '',
            filterPlaceholder: lang.get(
                'user.type_the_therapist_name_to_search'),
            noResults: lang.get('bids.no_data'),
            loading: lang.get('home.labels.loading_message_table'),
          },
          columnsClasses: {
            action: 'text-right actions-cell',
            id: 'actions-cell',
          },
          perPage: 20,
        },
      };
    },
    components: {
      TableView, Loader, skillModal, clientBtn
    },

    computed: {
      ...mapGetters('mobile', [
        'isMobile',
      ]),
    },

    methods: {
      onModalClose() {
        this.modal.data = {};
        this.isModalVisible = false;
        this.isChange = true;
      },

      onModalBtnClick(item) {
        this.modal.data = item;
        this.isModalVisible = true;
        this.isChange = false;
      },

      onAddModalBtnClick(){
        this.modal.data = {
          name: ''
        };
        this.isModalVisible = true;
        this.isChange = false;
      },

      async onDeleteBtnClick(id) {
        this.isChange = false;
        let response = await Manager.deleteSkillDomain(id);

        if(response){
          this.isChange = true;
        }
      },

      isLast: function ({option}) {
        return option.id == this.lastId;
      },

      async requestFunction(data) {
        localStorage.setItem('currentPage', data.page);
        localStorage.setItem('currentPageHeader', 'skillDomain');
        let response = await Manager.getSkillDomain(data.limit, data.page);
        return response;
      },

    },

  };
</script>



// WEBPACK FOOTER //
// src/modules/profile/components/SkillDomain.vue